import React from 'react'
import Titulo from '../../UI/Blog/Titulo.jsx'
import TituloPrincipal from '../../UI/Blog/TituloPrincipal.jsx'

const ConteudoTodoPrincipal = () => {
  return (
    <div>
        <br /><br /><br /><br />
      <Titulo />
      <TituloPrincipal />
    </div>
  )
}

export default ConteudoTodoPrincipal